import styled from "styled-components";
import PropTypes from "prop-types";

import VStack from "shared/components/layout/stack/VStack";
import Text from "shared/components/data-display/text/Text";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";

const Container = styled(VStack)`
    margin-top: 1.5rem;
    text-align: left;
    padding: 0px;
    gap: 8px;
`;

const ButtonWrapper = styled(VStack)`
    align-items: start;
    padding: 0px;
    gap: 4px;
`;

const LinkGroup = ({ linkData, label }) => {
    const data = Object.values(linkData)?.every((e) => !e?.name);

    return data ? (
        <></>
    ) : (
        <Container>
            {label && (
                <Text variant="Descriptive_1_1" color="Gray_2">
                    {label}
                </Text>
            )}
            {linkData.map(
                (data) =>
                    data.name && (
                        <ButtonWrapper key={data.name}>
                            <TertiaryButton
                                trailingIcon="caret-right"
                                label={data.name}
                                href={data.to}
                                key={data.name}
                                target="_blank"
                            />
                        </ButtonWrapper>
                    )
            )}
        </Container>
    );
};

LinkGroup.propTypes = {
    linkData: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            to: PropTypes.string,
        })
    ).isRequired,
    label: PropTypes.string,
};

export default LinkGroup;
